import React, { useEffect } from 'react';
import {
    Box,
    Button,
    Typography,
    Paper,
    Stack,
    useTheme,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

type UnauthorizedProps = {
    onLogin?: () => void;
};

const Unauthorized: React.FC<UnauthorizedProps> = ({ onLogin }) => {
    const theme = useTheme();

    useEffect(() => {
        // save the url before redirecting to log in
        const { search, pathname } = window.location;
        let urlToSave = '';

        if (pathname !== '/') {
            urlToSave = pathname;
        }

        if (search) {
            urlToSave += search;
        }

        if (urlToSave) {
            localStorage.setItem('preLoginURL', urlToSave);
        }
    }, []);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: theme.palette.grey[100],
                px: 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    maxWidth: 420,
                    width: '100%',
                    borderRadius: 3,
                    p: { xs: 3, sm: 4 },
                    textAlign: 'center',
                }}
            >
                <Box
                    sx={{
                        width: 64,
                        height: 64,
                        borderRadius: '50%',
                        mb: 2.5,
                        mx: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: '#007bff',
                    }}
                >
                    <LockOutlinedIcon sx={{ fontSize: 32, color: theme.palette.primary.contrastText }}/>
                </Box>

                <Typography variant="h5" component="h1" sx={{ mb: 1 }}>
                    Private page
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    This page is only available to logged-in users.
                    Please sign in to continue.
                </Typography>

                {onLogin && (
                    <Stack spacing={1.5}>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={onLogin}
                            sx={{
                                borderRadius: 999,
                                textTransform: 'none',
                                fontWeight: 600,
                                py: 1.1,
                                backgroundColor: '#013b71',
                                '&:hover': {
                                    backgroundColor: '#012d55',
                                },
                            }}
                        >
                            Log in
                        </Button>

                        <Typography variant="caption" color="text.secondary">
                            You will be redirected back to this page after logging in.
                        </Typography>
                    </Stack>
                )}
            </Paper>
        </Box>
    );
};

export default Unauthorized;